<template>
  <el-submenu
    v-if="menu.children && menu.children.length >= 1"
    :index="'' + menu.menuId"
    :popper-append-to-body="false"
    ><!--解决vue2+elementUI 无限导航递归报错-->
    <template slot="title">
      <i :class="menu.icon" style="color:#999999;font-size:0.98rem"></i>&nbsp;
      <span slot="title" style="color:#999999;">{{ menu.name }}</span>
    </template>
    <MenuTree
      v-for="item in menu.children"
      :key="item.menuId"
      :menu="item"
    ></MenuTree>
  </el-submenu>
  <el-menu-item v-else :index="'' + menu.menuId" @click="handleRoute(menu)">
    <!-- <i :class="menu.icon"></i> -->
    <span style="font-size:14px" slot="title">{{ menu.name }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: "MenuTree",
  props: {
    menu: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleRoute(menu) {
      // 通过菜单URL跳转至指定路由
      this.$router.push("/" + menu.url);
    }
  }
};
</script>

<style scoped lang="scss">
.el-menu-item.is-active {
  color: #409eff;
  background: #ecf5ff;
}
.el-menu-item {
  color: #444444;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuTree/index.vue